import { Box, Container, Typography } from '@mui/material';
import { useSelector } from 'react-redux';

const ShippingDelivery = () => {
    const { address, email } = useSelector(state => state.shop)

    const content = `<h2>Shipping & Delivery</h2>
    <h4>Shipping Information</h4>

    <p><strong>Processing Time</strong></p>
    <p>Most orders are shipped within 1 day after the payment is processed. Once your order has shipped, we will provide you with a tracking number that will allow you to track your package.</p>

    <p><strong>Delivery Time and Shipping Fee</strong></p>

    <table>
      <thead>
        <tr>
          <th>&nbsp;</th>
          <th>Handling Time</th>
          <th>Transit Time</th>
          <th>Costs</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Standard Delivery</td>
          <td>1-2 Business Days</td>
          <td>4-5 Business Days</td>
          <td>$4.99</td>
        </tr>
      </tbody>
    </table>

    <p><strong>* Important:</strong></p>
    <ol>
      <li>Most orders will ship via <strong>UPS</strong> or <strong>FedEx Ground</strong>, unless otherwise noted.</li>
      <li>We do not ship to <strong>Alaska</strong>, <strong>Hawaii</strong>, <strong>Puerto Rico</strong>, <strong>Guam</strong>, the <strong>US Virgin Islands</strong>, or internationally.</li>
      <li>We do not ship to <strong>APO/FPO</strong> addresses.</li>
      <li>We currently do not offer shipping outside of the <strong>48 contiguous states</strong>.</li>
    </ol>

    <p><strong>Note:</strong> The shipping time is calculated using calendar days and should be used as a general guide. Shipping delays may be caused by natural disasters, inclement weather, war, public holidays, or other factors outside our control.</p>`
    return (
        < Container >
            <Box
                sx={{
                    width: '100%', overflowX: 'auto', mb: 4, '& table': {
                        width: '100%',
                        borderCollapse: 'collapse',
                        marginBottom: '32px',
                        fontSize: '0.95rem',
                        textAlign: 'center',
                    },
                    '& table th, & table td': {
                        border: '1px solid #ddd',
                        padding: '10px 12px',
                    },
                    '& table thead': {
                        backgroundColor: '#f5f5f5',
                        fontWeight: 'bold',
                    },
                    '& table tr:nth-of-type(even)': {
                        backgroundColor: '#fafafa',
                    }
                }}
                dangerouslySetInnerHTML={{ __html: content.replace(/Localhost/g, `${window.location.hostname}`) }}
            />
            <Typography ><b>Address:</b> {address}</Typography>
            <Typography ><b>Email:</b> {email || `support@${window.location.hostname}`}</Typography>
            <Typography ><b>Support Time:</b> 8:00 AM – 5:00PM (EST) (Mon – Fri)</Typography>
        </Container >
    )
};

export default ShippingDelivery;
